<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg3957"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs3961"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath3971"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path3969" /></clipPath></defs><g
     id="g3963"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g3965"><g
         id="g3967"
         clip-path="url(#clipPath3971)"><g
           id="g3973"
           transform="translate(214.5996,375.9482)"><path
             d="m 0,0 h -207.1 v 49.041 c 0,19.02 15.535,34.582 34.555,34.582 h 15.761 m 347.555,0 h 15.734 c 19.02,0 34.583,-15.562 34.583,-34.582 L 241.088,0 H 33.987 m 52.47,83.623 h 69.647 m -173.934,0 h 69.647 m -173.963,0 h 69.648"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3975" /></g><g
           id="g3977"
           transform="translate(455.6875,312.877)"><path
             d="M 0,0 V -117.864 M 0,63.071 V 33.959 M -448.187,-165.883 V 63.071 m 309.968,-308.977 h -278.475 c -17.32,0 -31.493,14.173 -31.493,31.494 v 14.57"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3979" /></g><g
           id="g3981"
           transform="translate(283.7363,500.6455)"><path
             d="m 0,0 v 0 c 9.524,0 17.32,-7.795 17.32,-17.32 v -47.112 c 0,-9.524 -7.796,-17.32 -17.32,-17.32 -9.524,0 -17.319,7.796 -17.319,17.32 V -17.32 C -17.319,-7.795 -9.524,0 0,0 Z m -104.286,0 v 0 c 9.524,0 17.319,-7.795 17.319,-17.32 v -47.112 c 0,-9.524 -7.795,-17.32 -17.319,-17.32 -9.553,0 -17.349,7.796 -17.349,17.32 v 47.112 c 0,9.525 7.796,17.32 17.349,17.32 z m -104.316,0 v 0 c 9.525,0 17.32,-7.795 17.32,-17.32 v -47.112 c 0,-9.524 -7.795,-17.32 -17.32,-17.32 -9.524,0 -17.319,7.796 -17.319,17.32 v 47.112 c 0,9.525 7.795,17.32 17.319,17.32 z m 312.917,-0.199 v 0 c 9.525,0 17.32,-7.795 17.32,-17.32 v -47.112 c 0,-9.523 -7.795,-17.348 -17.32,-17.348 -9.552,0 -17.348,7.825 -17.348,17.348 v 47.112 c 0,9.525 7.796,17.32 17.348,17.32 z"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3983" /></g><path
           d="m 54.3,240.594 h 88.583 v 88.555 H 54.3 Z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3985" /><path
           d="m 54.3,113.801 h 88.583 v 88.554 H 54.3 Z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3987" /><path
           d="m 187.302,240.594 h 88.555 v 88.555 h -88.555 z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3989" /><path
           d="m 187.302,113.801 h 88.555 v 88.554 h -88.555 z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3991" /><path
           d="m 320.304,240.594 h 88.554 v 88.555 h -88.554 z"
           style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path3993" /><g
           id="g3995"
           transform="translate(348.7354,188.9473)"><path
             d="m 0,0 c 16.157,11.764 36.085,18.68 57.6,18.68 54.227,0 98.165,-43.938 98.165,-98.135 0,-54.2 -43.938,-98.138 -98.165,-98.138 -54.199,0 -98.136,43.938 -98.136,98.138 0,20.437 6.265,39.43 16.951,55.162"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path3997" /></g><g
           id="g3999"
           transform="translate(406.335,175.5391)"><path
             d="M 0,0 V -66.047 L -46.148,-120.36"
             style="stroke:#000000;stroke-width:14.995;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path4001" /></g></g></g></g></svg>
</template>
